<template>
  <div class="sampleData">
    <el-row class="header-row">
      <span class="sample-title">{{removeLables(title)}}(ID: {{surveyId}})</span>
    </el-row>
    <el-row class="header-row">
      <el-col :span="9">
        <span>选择时间</span>
        <el-date-picker
          v-model="dataRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="datePickerOptions"
          @change="handleDateChange"
          size="small"
        ></el-date-picker>
      </el-col>
      <el-col :span="4">
        <span>显示条数</span>
        <el-select v-model="pageSizes" size="small" class="page-size" @change="handleSizeChange">
          <el-option
            v-for="(item, index) in pageSizesOption"
            :label="item"
            :value="item"
            :key="index"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="5" style="visibility: hidden">
        <span>数据类型</span>
        <el-select
          v-model="dataType"
          @change="handleDataTypeChange"
          size="small"
          class="page-dataType"
        >
          <el-option
            v-for="(item, index) in dataTypeOptions"
            :label="item.label"
            :value="item.value"
            :disabled="notFilter && (item.value == 'filtered' || item.value == 'deleted')"
            :key="index"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <div class="pull-right" v-if="role!=2">
          <span v-if="dataType !== 'deleted'">
            <el-button
              type="text"
              :disabled="dataType == 'incomplete'"
              @click="handleDataCleanClick"
            >{{!confirmFlag ? '清洗' : '继续清洗'}}</el-button>
          </span>
          <el-button type="text" @click="handleRecover" v-if="dataType == 'deleted'">移至清洗后</el-button>
          <span>|</span>
          <el-button
            type="text"
            @click="handleDelete"
            v-if="dataType !== 'deleted' && dataType !== 'incomplete'"
          >删除</el-button>
          <el-button
            type="text"
            @click="handleDelete"
            v-if="dataType == 'deleted' || dataType == 'incomplete'"
          >彻底删除</el-button>
          <span>|</span>
          <el-button type="text" @click="handleDownloadClick">下载</el-button>
        </div>
        <div class="pull-right" v-else>
          <span v-if="dataType !== 'deleted'">
            <el-button
              type="text"
              class="inactive"
              :disabled="true"
            >{{!confirmFlag ? '清洗' : '继续清洗'}}</el-button>
          </span>
          <el-button
            type="text"
            :disabled="true"
            @click="handleRecover"
            v-if="dataType == 'deleted'"
          >移至清洗后</el-button>
          <span>|</span>
          <el-button
            type="text"
            :disabled="true"
            v-if="dataType !== 'deleted' && dataType !== 'incomplete'"
          >删除</el-button>
          <el-button
            type="text"
            :disabled="true"
            v-if="dataType == 'deleted' || dataType == 'incomplete'"
          >彻底删除</el-button>
          <span>|</span>
          <el-button type="text" :disabled="true">下载</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="confirmFlag">
      <div class="clean-terms-disp">
        <span class="clean-terms-disp-title">
          <b>清洗条件</b>(
          <el-button
            type="text"
            :disabled="dataType == 'incomplete'"
            @click="showDialogDataClean = true"
          >修改</el-button>)
        </span>
        <p v-if="cleanTerms.tl">
          答题时长 小于
          <b>{{formatTime(cleanTerms.tl)}}</b>
        </p>
        <div v-if="cleanTerms.terms.length > 0" v-for="(term, i) in cleanTerms.terms" :key="i">
          <p v-if="term.length > 1">
            <span class="and-slot" v-for="(item, idx) in term" :key="idx">
              ({{removeLables(item.title)}}
              <b>{{operator2Label[item.operator]}}</b>
              {{item.opt}})
            </span>
          </p>
          <p v-if="term.length == 1">
            {{removeLables(term[0].title)}}
            <b>{{operator2Label[term[0].operator]}}</b>
            {{term[0].opt}}
          </p>
        </div>
        <p v-if="cleanTerms.ques.length > 0">
          第
          <b>{{cleanTerms.ques.join()}}</b> 题答案
          <b>相同</b>
        </p>
      </div>
      <el-button class="clean-terms-clear" icon="el-icon-delete" type="text" @click="handleClear">清空</el-button>
    </el-row>
    <el-table
      id="myId"
      :data="sampleDataTable"
      :highlight-current-row="true"
      tooltip-effect="light"
      border
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55"></el-table-column>
      <el-table-column prop="id" align="center" label="编号" width="100"></el-table-column>
      <el-table-column prop="startTime" align="center" label="答题时间" width="200"></el-table-column>
      <el-table-column prop="finishTime" align="center" label="时长" width="120">
        <template
          slot-scope="scope"
        >{{ scope.row.finishTime ? formatTime(scope.row.finishTime) : '-' }}</template>
      </el-table-column>
      <el-table-column v-if="evaluateFlag" align="center" label="评测得分">
        <template slot-scope="scope">{{ scope.row.totalScore }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        width="150"
        label-class-name="titleColumn"
        :show-overflow-tooltip="true"
        v-for="(ques, i) in allQues"
        :label="(i + 1) + '.' + removeLables(ques.title)"
        :key="i"
      >
        <template slot-scope="scope">
          <p class="answerDisp">{{findAnswer(scope.row.pages, ques.id)}}</p>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-center">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSizes"
        layout="total, prev, pager, next"
        :total="totalRecord"
      ></el-pagination>
    </div>
    <el-dialog title="数据下载" :visible.sync="showDialogDownload">
      <el-row class="delete-row">
        <el-checkbox-group v-model="downloadExcelType">
          <el-checkbox
            v-for="(item, index) in downloadTypeOptions"
            :label="item.label"
            :value="item.value"
            :key="index"
          ></el-checkbox>
        </el-checkbox-group>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialogDownload=false">取消</el-button>
        <el-button type="primary" @click="handleConfirmDown">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="数据清洗" width="750px" :visible.sync="showDialogDataClean">
      <span slot="title" class="dialog-title">
        <span class="dataDialog-title">清洗条件设置</span>
        <i class="el-icon-info">满足任一条件的数据将被移至垃圾桶</i>
      </span>
      <div class="data-clean-term">
        <span
          v-if="!cleanTerms.tl && cleanTerms.terms.length == 0 && cleanTerms.ques.length == 0"
          class="data-clean-term-tips"
        >请设置条件</span>
        <p v-if="cleanTerms.tl">
          1. 答题时长 小于
          <b>{{formatTime(cleanTerms.tl)}}</b>
        </p>
        <div v-if="cleanTerms.terms.length > 0" v-for="(term, i) in cleanTerms.terms" :key="i">
          <p v-if="term.length > 1">
            <span>{{ cleanTerms.tl ? (2 + i) + '. ' : (1 + i) + '. ' }}</span>
            <span class="and-slot" v-for="(item, idx) in term" :key="idx">
              ({{removeLables(item.title)}}
              <b>{{operator2Label[item.operator]}}</b>
              {{item.opt}})
            </span>
          </p>
          <p v-if="term.length == 1">
            <span>{{ cleanTerms.tl ? (2 + i) + '. ' : (1 + i) + '. ' }}</span>
            {{removeLables(term[0].title)}}
            <b>{{operator2Label[term[0].operator]}}</b>
            {{term[0].opt}}
          </p>
        </div>
        <p v-if="cleanTerms.ques.length > 0">
          <span>{{ cleanTerms.tl ? (cleanTerms.terms.length + 2) + '. ' : (cleanTerms.terms.length + 1) + '. ' }}</span>
          第
          <b>{{cleanTerms.ques.join()}}</b> 题答案
          <b>相同</b>
        </p>
      </div>
      <div class="data-clean-setting">
        <div class="data-clean-setting-sidebar">
          <ul class="setting-tabs">
            <li
              :class="{'setting-tabs-item': true, 'active': cleanSettingTab === 0}"
              @click="() => {this.cleanSettingTab = 0;}"
            >时长清洗</li>
            <li
              :class="{'setting-tabs-item': true, 'active': cleanSettingTab === 1}"
              @click="() => {this.cleanSettingTab = 1;}"
            >选项清洗</li>
            <li
              :class="{'setting-tabs-item': true, 'active': cleanSettingTab === 2}"
              @click="() => {this.cleanSettingTab = 2;}"
            >题目清洗</li>
          </ul>
        </div>
        <div class="setting-box" v-if="cleanSettingTab === 0">
          <div v-if="maxTimeLong != minTimeLong" class="time-long-setting">
            <p class="pull-left">平均作答时长为{{formatTime(avgTime)}}</p>
            <el-button type="text" @click="handleResetTl" class="reset-timelong-btn">重置</el-button>
            <el-slider
              v-model="timeLong"
              :max="maxTimeLong"
              :min="minTimeLong"
              :format-tooltip="formatTime"
              @change="handleSliderTime"
            ></el-slider>
            <p class="time-long-setting-tips">
              <span class="pull-left">
                作答时长小于
                <b>{{formatTime(timeLong)}}</b>的数据将被清洗
              </span>
              <span class="pull-right">{{formatTime(maxTimeLong)}}</span>
            </p>
          </div>
          <p v-else class="tl-error-tips">回收量小于1不支持时长清洗</p>
        </div>
        <div class="setting-box" v-if="cleanSettingTab === 1">
          <el-button type="text" class="add-term-tab" @click="handleTabsAdd">+ 添加条件组</el-button>
          <el-tabs v-model="termsTabsValue" closable @tab-remove="handleTabsRemove">
            <el-tab-pane
              :key="tab.name"
              v-for="(tab, index) in termsTabs"
              :label="'条件组' + (index + 1)"
              :name="tab.name"
            >
              <div class="terms-row" v-for="(term, idx) in tab.terms" :key="idx">
                <el-select
                  v-model="term.quesIdx"
                  @change="(val) => {handleTermType(val, term)}"
                  placeholder="请选择题目"
                >
                  <el-option
                    v-for="item in allQues"
                    :key="item.index"
                    :label="(item.index + 1) + '.' + removeLables(item.title)"
                    :disabled="item.type != 'radio' && item.type != 'checkbox' && item.type != 'select' && item.type != 'star'"
                    :value="item.index"
                  ></el-option>
                </el-select>
                <el-select class="operator-selector" v-model="term.operator" placeholder="请选择逻辑">
                  <el-option
                    v-for="item in operatorMap[term.ques.type]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select v-if="term.ques.options" v-model="term.optIdx" placeholder="请选择选项">
                  <el-option
                    v-for="(item, i) in term.ques.options"
                    :key="item.id"
                    :label="item.text"
                    :value="i"
                  ></el-option>
                </el-select>
                <el-select v-else v-model="term.optIdx" placeholder="请选择选项">
                  <el-option
                    v-for="i in term.ques.starNum"
                    :key="term.ques.starBeginNum + i - 1"
                    :label="term.ques.starBeginNum + i - 1"
                    :value="term.ques.starBeginNum + i - 1"
                  ></el-option>
                </el-select>
                <i class="el-icon-close" @click="handleDelTerm(index, idx)"></i>
              </div>
              <el-button class="add-term-btn" type="text" @click="handleAddTerm(index)">+添加条件</el-button>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="setting-box" v-if="cleanSettingTab === 2">
          <el-select
            class="ques-filter"
            v-model="quesFilter"
            multiple
            placeholder="仅针对打分题，多个打分题答案相同则该条数据将移至垃圾桶"
            @change="handleQuesFilter"
          >
            <el-option
              v-for="item in allQues"
              :key="item.id"
              :label="(item.index + 1) + '. ' + removeLables(item.title)"
              :value="item.id"
              v-if="item.type == 'star'"
            ></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirmSetting">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { dataTypeMixin } from "../utils/mixins.js";
import http from "../utils/http";
import { MSG } from "../utils/utils";
import { timeToLocal } from "../utils/utils";
import { DOMAIN } from "../utils/api";
import { mapGetters } from "vuex";

const dataTypeMap = {
  全部数据: "1",
  完整数据: "2",
  不完整数据: "3",
  清洗后数据: "4",
  垃圾桶数据: "5"
};
export default {
  name: "sampleData",
  mixins: [dataTypeMixin],
  watch: {
    termsTabs: {
      handler: function() {
        this.cleanTerms.terms = [];
        this.termsTabs.forEach(val => {
          let _terms = [];
          val.terms.forEach(term => {
            if (
              typeof term.quesIdx !== "number" ||
              !term.operator ||
              typeof term.optIdx !== "number"
            )
              return;
            let _term = {
              title: term.ques.title,
              operator: term.operator,
              opt: term.ques.options
                ? term.ques.options[term.optIdx].text
                : term.optIdx,
              index: term.ques.index,
              qid: term.ques.id,
              oid: term.ques.options
                ? term.ques.options[term.optIdx].id
                : term.optIdx,
              optIdx: term.ques.options ? term.optIdx + 1 : term.optIdx
            };
            _terms.push(_term);
          });
          if (_terms.length > 0) this.cleanTerms.terms.push(_terms);
        });
      },
      deep: true
    }
  },
  data() {
    return {
      interface: {
        getSampleData: `/stat/sampleData`,
        dataFilter: `/stat/dataFilter`,
        outData: `/stat/exportData`,
        delAnswer: `/stat/deleteOrRecoverAnswer`,
        delUnfinishAnswer: `/stat/deleteUnfinishAnswer`,
        exportData: `${DOMAIN}/analysis/exportData`
      },
      Role: window.sessionStorage.getItem("role"),
      pageSizes: 10,
      pageSizesOption: [10, 20, 50, 100],
      sampleDataTable: [],
      currentPage: 1,
      totalRecord: 0,
      showDialogDownload: false,
      showDialogDataClean: false,
      downloadExcelType: [],
      downloadSpssType: [],
      downloadTypeList: [
        {
          label: "全部数据",
          value: "1"
        },
        {
          label: "完整数据",
          value: "2"
        },
        {
          label: "不完整数据",
          value: "3"
        },
        {
          label: "清洗后数据",
          value: "4"
        },
        {
          label: "垃圾桶数据",
          value: "5"
        }
      ],
      survey: {
        pages: []
      },
      evaluateFlag: false,
      cleanTerms: {
        tl: null,
        terms: [],
        ques: []
      },
      cleanSettingTab: 0,
      timeLong: 0,
      minTimeLong: 20,
      maxTimeLong: 100,
      avgTime: 0,
      operatorMap: {
        radio: [
          { value: "==", label: "选中" },
          { value: "!==", label: "未选中" }
        ],
        select: [
          { value: "==", label: "选中" },
          { value: "!==", label: "未选中" }
        ],
        checkbox: [
          { value: "=", label: "包含" },
          { value: "!=", label: "不包含" }
        ],
        star: [
          { value: ">", label: "大于" },
          { value: "<", label: "小于" },
          { value: ">=", label: "大于等于" },
          { value: "<=", label: "小于等于" },
          { value: "==", label: "等于" }
        ]
      },
      operator2Label: {
        "=": "包含",
        "!=": "不包含",
        "==": "选中",
        "!==": "未选中",
        ">=": "大于等于",
        "<=": "小于等于",
        ">": "大于",
        "<": "小于"
      },
      termsTabsValue: "1",
      tabIndex: 1,
      termsTabs: [
        {
          name: "1",
          title: "条件组1",
          terms: []
        }
      ],
      quesFilter: [],
      multipleSelection: [],
      confirmFlag: false,
      notFilter: true,
      datePickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    allQues() {
      let _quesArr = [];
      if (this.survey && this.survey.pages) {
        this.survey.pages.forEach(page => {
          console.log(page)
          page.questions.forEach(ques => {
            if (ques.type !== "description") _quesArr.push(ques);
          });
        });
      }
      return _quesArr;
    },
    ...mapGetters(["role"])
  },
  mounted() {
    let { id, title } = this.$route.query;
    this.title = title;
    this.surveyId = id;
    if (localStorage.getItem("expr")) {
      this.confirmFlag = true;
      this.notFilter = false;
      this.dataType = "filtered";
      this.cleanTerms = JSON.parse(localStorage.getItem("expr"));
    }
    this.getList();
    setTimeout(function() {
      if (
        !/Chrome/g.test(navigator.userAgent) &&
        /Safari/g.test(navigator.userAgent)
      ) {
        $("#myId")
          .find("table")
          .find("th.gutter")
          .remove();
      }
    }, 500);
  },
  methods: {
    getList() {
      http
        .get(this.interface.getSampleData, {
          surveyId: this.surveyId,
          page: this.currentPage,
          pageSize: this.pageSizes,
          startDate: this.dataRange ? timeToLocal(this.dataRange[0]).date : "",
          endDate: this.dataRange ? timeToLocal(this.dataRange[1]).date : "",
          dataType: this.dataType
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            data.sampleDataList.forEach(val => {
              val.startTime = timeToLocal(new Date(+val.startTime)).datetime;
              val.endTime = timeToLocal(new Date(+val.endTime)).datetime;
            });
            this.sampleDataTable = data.sampleDataList;
            this.survey = data.survey;
            this.evaluateFlag = data.evaluateFlag === 1;
            this.totalRecord = data.totalCount;
            this.maxTimeLong = +data.maxTime || 0;
            this.minTimeLong = +data.minTime || 0;
            this.avgTime = data.avgTime;
            this.timeLong = this.timeLong || +data.minTime;
          } else {
            MSG.error(message);
          }
        });
    },
    handleDownloadClick() {
      this.showDialogDownload = true;
    },
    handleDataCleanClick() {
      this.showDialogDataClean = true;
    },
    handleSizeChange() {
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    handleDateChange() {
      this.getList();
    },
    findAnswer(pages, id) {
      for (let _page = 0; _page < pages.length; _page++) {
        for (let _ques = 0; _ques < pages[_page].questions.length; _ques++) {
          const ques = pages[_page].questions[_ques];
          if (ques.id === id) {
            switch (ques.type) {
              case "radio":
              case "select":
                for (let i = 0; i < ques.options.length; i++) {
                  if (ques.options[i].checked === 1) {
                    return ques.options[i].text;
                  }
                }
              case "checkbox":
                let _arr = [];
                for (let i = 0; i < ques.options.length; i++) {
                  if (ques.options[i].checked === 1) {
                    _arr.push(ques.options[i].text || i + 1);
                  }
                }
                return _arr.join();
              case "star":
                return ques.text;
              case "textarea":
                return ques.text;
              case "date":
                return ques.text;
              case "region":
                return ques.text;
              case "upload":
                return ques.fileNameSrc;
              case "sort":
                let _sort = [];
                for (let i = 0; i < ques.options.length; i++) {
                  _sort.push(ques.options[i].text);
                }
                return _sort.join();
              case "matrixStar":
                let _mStar = [];
                for (let i = 0; i < ques.groups.length; i++) {
                  _mStar.push(ques.groups[i].text);
                }
                return _mStar.join();
              case "matrixRadio":
              case "matrixCheckbox":
                let _mCheck = [];
                for (let i = 0; i < ques.groups.length; i++) {
                  for (let j = 0; j < ques.groups[i].options.length; j++) {
                    if (ques.groups[i].options[j].checked === 1) {
                      _mCheck.push(ques.groups[i].options[j].text);
                    }
                  }
                }
                return _mCheck.join();
              case "chainedSelects":
                return ques.textList.join();
              case "textMultiple":
                let _text = [];
                for (let i = 0; i < ques.blanks.length; i++) {
                  _text.push(ques.blanks[i].value);
                }
                return _text.join();
            }
          }
        }
      }
    },
    handleDataTypeChange() {
      this.currentPage = 1;
      this.getList();
    },
    removeLables(html) {
      if (html) {
        return html.replace(/<\/?.+?>/g, "");
      } else {
        return "";
      }
    },
    formatTime(result) {
      const h =
        Math.floor(result / 3600) > 0 ? `${Math.floor(result / 3600)}时` : "";
      const m =
        Math.floor((result / 60) % 60) > 0
          ? `${Math.floor((result / 60) % 60)}分`
          : "";
      const s = `${Math.floor(result % 60)}秒`;
      return (result = h + m + s);
    },
    handleTermType(value, term) {
      term.ques = this.allQues[value];
      term.operator = null;
      term.optIdx = null;
    },
    handleTabsAdd() {
      let newTabName = ++this.tabIndex + "";
      this.termsTabs.push({
        title: "条件组" + newTabName,
        name: newTabName,
        terms: [
          {
            quesIdx: null,
            operator: null,
            optIdx: null,
            ques: {}
          }
        ]
      });
      this.termsTabsValue = newTabName;
    },
    handleTabsRemove(targetName) {
      let tabs = this.termsTabs;
      let activeName = this.termsTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.termsTabsValue = activeName;
      this.termsTabs = tabs.filter(tab => tab.name !== targetName);
    },
    handleAddTerm(val) {
      this.termsTabs[val].terms.push({
        quesIdx: null,
        operator: null,
        optIdx: null,
        ques: {}
      });
    },
    handleDelTerm(tabIdx, termIdx) {
      this.termsTabs[tabIdx].terms.splice(termIdx, 1);
    },
    handleSliderTime() {
      if (this.timeLong === this.minTimeLong) {
        this.cleanTerms.tl = null;
      } else {
        this.cleanTerms.tl = this.timeLong;
      }
    },
    handleQuesFilter() {
      let _arr = [];
      this.allQues.forEach(val => {
        if (this.quesFilter.indexOf(val.id) > -1) {
          _arr.push(val.index + 1);
        }
      });
      this.cleanTerms.ques = _arr.sort(function(a, b) {
        return a - b;
      });
    },
    handleClear() {
      this.cleanTerms = {
        tl: null,
        terms: [],
        ques: []
      };
      this.termsTabs = [
        {
          name: "1",
          title: "条件组1",
          terms: []
        }
      ];
      this.confirmFlag = false;
      this.termsTabsValue = "1";
      this.timeLong = this.minTimeLong;
      this.quesFilter = [];
      this.dataType = "complete";
      this.notFilter = true;
      localStorage.setItem("expr", "");
      this.getList();
    },
    isTermsComplete() {
      let flag = true;
      for (let i = 0; i < this.termsTabs.length; i++) {
        for (let j = 0; j < this.termsTabs[i].terms.length; j++) {
          if (
            typeof this.termsTabs[i].terms[j].quesIdx !== "number" ||
            !this.termsTabs[i].terms[j].operator ||
            typeof this.termsTabs[i].terms[j].optIdx !== "number"
          ) {
            flag = false;
            return flag;
          }
        }
      }
      return flag;
    },
    handleConfirmSetting() {
      if (!this.isTermsComplete()) {
        MSG.error("请完成所有配置");
        return;
      }
      let tips = "数据清洗后将无法恢复, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.confirmSetting();
      });
    },
    confirmSetting() {
      let expression = "";
      if (typeof this.cleanTerms.tl === "number") {
        expression += "TL<" + this.cleanTerms.tl;
      }
      if (this.cleanTerms.terms.length > 0) {
        if (expression) expression += "|";
        this.cleanTerms.terms.forEach((term, idx) => {
          let _exp = "";
          if (term.length > 1) {
            term.forEach((val, i) => {
              _exp += "(" + val.qid + val.operator + val.oid + ")";
              if (i !== term.length - 1) {
                _exp += "&";
              }
            });
          } else {
            _exp += "(" + term[0].qid + term[0].operator + term[0].oid + ")";
          }
          if (idx !== this.cleanTerms.terms.length - 1) {
            _exp += "|";
          }
          expression += _exp;
        });
      }
      if (this.quesFilter.length > 0) {
        if (expression) expression += "|";
        expression += "QF=" + this.quesFilter.join("+");
      }

      this.showDialogDataClean = false;
      this.confirmFlag = true;
      if (!expression) {
        this.confirmFlag = false;
        this.notFilter = true;
        this.dataType = "complete";
        this.getList();
        return;
      }
      http
        .post(this.interface.dataFilter, {
          surveyId: this.surveyId,
          expr: expression
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
          } else {
            MSG.error(message);
          }
        });
    },
    handleCancel() {
      this.showDialogDataClean = false;
      if (!this.confirmFlag) {
        this.timeLong = this.minTimeLong;
        this.cleanTerms.tl = null;
      }
    },
    handleConfirmDown1() {
      if (this.downloadExcelType.length > 0) {
        this.downloadExcelType.forEach(val => {
          let excelUrl = `${this.interface.outData}?surveyId=${this.surveyId}&type=excel&dataType=${dataTypeMap[val]}`;
          window.open(excelUrl);
        });
      }
      if (this.downloadSpssType.length > 0) {
        this.downloadSpssType.forEach(val => {
          let spssUrl = `${this.interface.outData}?surveyId=${this.surveyId}&type=spss&dataType=${dataTypeMap[val]}`;
          window.open(spssUrl);
        });
      }
      this.showDialogDownload = false;
    },
    handleConfirmDown() {
      if (this.downloadExcelType.length > 0) {
        var startDate = this.dataRange
          ? timeToLocal(this.dataRange[0]).date
          : "";
        var endDate = this.dataRange ? timeToLocal(this.dataRange[1]).date : "";
        this.downloadExcelType.forEach(val => {
          var url = "";
          if (val == "导出excel数据") {
            url = `${this.interface.exportData}?surveyId=${this.surveyId}&type=excel&startDate=${startDate}&endDate=${endDate}`;
          } else {
            url = `${this.interface.exportData}?surveyId=${this.surveyId}&type=spss&startDate=${startDate}&endDate=${endDate}`;
          }
          window.open(url);
        });
      }
      this.showDialogDownload = false;
    },
    handleRecover() {
      if (this.multipleSelection.length === 0) {
        MSG.error("请先选中要操作的答案");
        return;
      }
      let _recoverArr = this.multipleSelection.map(val => {
        return val.id;
      });
      this.$confirm("恢复该填答, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        http
          .get(this.interface.delAnswer, {
            answerId: _recoverArr.join(),
            opType: "recover" //'delete'彻底删除, 'recover'从垃圾箱恢复
          })
          .then(response => {
            const { code, data, message } = response;
            if (code === 1) {
              this.getList();
              MSG.success("操作成功");
            } else {
              MSG.error(message);
            }
          })
          .catch(error => {
            MSG.error(error);
          });
      });
    },
    handleDelete() {
      if (this.multipleSelection.length === 0) {
        MSG.error("请先选中要操作的答案");
        return;
      }
      let _delArr = this.multipleSelection.map(val => {
        return val.id;
      });
      let opType = null;
      if (this.dataType === "complete" || this.dataType === "filtered") {
        opType = "dustbin";
      } else if (this.dataType === "deleted") {
        opType = "delete";
      }
      let api =
        this.dataType === "incomplete"
          ? this.interface.delUnfinishAnswer
          : this.interface.delAnswer;
      let tips =
        opType === "delete" || this.dataType === "incomplete"
          ? "删除数据后将无法恢复, 是否继续?"
          : "删除数据后将无法恢复，是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        http
          .get(api, {
            answerId: _delArr.join(),
            opType: opType //'delete'彻底删除, 'recover'从垃圾箱恢复
          })
          .then(response => {
            const { code, data, message } = response;
            if (code === 1) {
              this.getList();
              MSG.success("操作成功");
            } else {
              MSG.error(message);
            }
          })
          .catch(error => {
            MSG.error(error);
          });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleResetTl() {
      this.timeLong = this.minTimeLong;
      this.cleanTerms.tl = null;
    }
  }
};
</script>
<style lang="scss">
div.sampleData {
  padding: 25px;
  height: 100%;
  background-color: #fff;
  color: #999;
  border: 1px solid #e7e7e7;
  overflow-y: auto;
  .header-row {
    .page-size {
      width: 90px;
    }
    .el-button--text {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .el-date-editor {
    width: 280px;
  }
  .el-range-separator {
    width: 10%;
  }
  .el-table th > .cell {
    font-weight: normal;
  }
  .sample-title {
    color: #333;
  }
  .el-dialog__header {
    padding-left: 20px;
    padding-right: 30px;
  }
  .el-tabs__nav-wrap::after {
    background-color: #ddd;
    height: 1px;
  }
  .dataDialog-title {
    font-size: 20px;
    color: #333;
  }
  .data-clean-term {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 8px;
    min-height: 80px;
    overflow-y: auto;
    margin-bottom: 15px;
  }
  .data-clean-term-tips {
    color: #999;
  }
  .data-clean-setting {
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 182px;
  }
  .data-clean-setting-sidebar {
    width: 100px;
    float: left;
  }
  .setting-tabs-item {
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
    text-align: center;
    background-color: #ddd;
    cursor: pointer;
    &:first-child {
      border-radius: 4px 0 0 0;
    }
    &:last-child {
      border-radius: 0 0 0 4px;
    }
    &.active {
      background-color: #fff;
      color: #ff552e;
    }
  }
  .setting-box {
    width: calc(100% - 101px);
    float: right;
    position: relative;
    height: 100%;
    overflow-y: auto;
    .el-select:not(.ques-filter) {
      margin-left: 10px;
      input {
        height: 30px;
        line-height: 30px;
      }
      .el-input__icon {
        line-height: 30px;
      }
    }
  }
  .time-long-setting {
    padding: 15px 30px;
    overflow: hidden;
  }
  .reset-timelong-btn {
    padding: 0;
    margin-left: 15px;
  }
  .time-long-setting-tips {
    overflow: hidden;
    b {
      color: #ff552e;
    }
  }
  .add-term-btn {
    margin-left: 10px;
    font-size: 12px;
    padding-top: 0;
  }
  .delete-row-1 {
    height: 70px;
  }
  .delete-row {
    height: 70px;
    .el-checkbox {
      display: table-row;
      height: 40px;
      line-height: 40px;
    }
  }
  .pager-center {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  .el-dialog__body {
    padding: 0px 20px;
  }
  .titleColumn {
    white-space: nowrap;
  }
  .answerDisp {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-slider__bar {
    background-color: #ff552e;
  }
  .el-tabs__nav-scroll {
    padding-left: 20px;
  }
  .add-term-tab {
    position: absolute;
    right: 10px;
    top: 0;
    font-weight: normal;
    cursor: pointer;
    z-index: 99;
  }
  .terms-row {
    margin-bottom: 10px;
    .el-select {
      width: 170px;
      input {
        text-align: center;
      }
    }
  }
  .and-slot + .and-slot {
    &:before {
      content: " 且 ";
      font-weight: bold;
    }
  }
  .ques-filter {
    margin: 15px auto;
    width: 90%;
    display: block;
  }
  .clean-terms-disp {
    background-color: #f5f5f5;
    padding: 0 15px 12px;
    width: 100%;
    margin-bottom: 15px;
    color: #666;
    overflow: hidden;
  }
  .clean-terms-disp-title {
    color: #555;
  }
  .clean-terms-clear {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -28px;
  }
  .tl-error-tips {
    padding: 20px;
  }
  .el-select__tags {
    span {
      width: 100%;
    }
  }
  .el-select .el-tag {
    width: 100%;
    min-width: 100px;
    span {
      width: calc(100% - 30px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }
    .el-tag__close {
      top: -7px;
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}
.export-data {
  display: inline-block;
  height: 60px;
  line-height: 60px;
  width: 200px;
  &:hover {
    color: #ff552e;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sampleData.vue